import clsx from 'clsx'
import Link from 'next/link'
import { useState } from 'react'

import phoneIcon from 'assets/svg/message-icon.svg'

import { Drawer } from '@/shared/ui/drawer'
import { Icon } from '@/shared/ui/icon'

import cl from './ContactDrawer.module.scss'

type ContactDrawerProps = {
	forFooter?: boolean
}

export const ContactDrawer = ({ forFooter }: ContactDrawerProps): JSX.Element => {
	const [open, setOpen] = useState(false)

	const showDrawer = () => {
		setOpen(true)
	}

	const onClose = () => {
		setOpen(false)
	}

	const triggerClasses = clsx(cl.trigger, forFooter && cl.triggerFooter)

	return (
		<section className={cl.root}>
			<button type="button" className={triggerClasses} onClick={showDrawer}>
				<Icon icon={phoneIcon} width={20} height={20} />
				{forFooter ? 'Остались вопросы? Свяжитесь с нами' : 'Связаться с нами'}
			</button>

			<Drawer
				isOpen={open}
				onClose={onClose}
				direction="bottom"
				title="Связаться с нами"
				contentClassName={cl.drawerContent}>
				<Link prefetch={false} href="tel:+7 800 77 000 97">
					+7 800 77 000 97
				</Link>

				<p className={cl.text}>
					Горячая линия <br /> 10:00 — 22:00, ежедневно
				</p>

				<Link prefetch={false} href="tel:+7 800 555 57 61">
					+7 800 555 57 61
				</Link>

				<p className={cl.text}>
					Сервисный центр <br />
					10:00 — 22:00, ежедневно
				</p>

				<Link prefetch={false} href="tel:+7 812 318 38 36">
					+7 812 318 38 36
				</Link>
				<Link prefetch={false} href="mailto:corp@iport.ru">
					corp@iport.ru
				</Link>

				<p className={cl.text}>
					Обслуживание юр.лиц
					<br />
					10:00 — 18:00, ежедневно
				</p>
			</Drawer>
		</section>
	)
}
